import { useCallback, useEffect, useState } from 'react'

import { api } from 'app/api'
import { GET_BANK_DETAILS, convertResult } from 'app/common/api/requests/account/bank_details/get'
import { POST_BANK_DETAILS, convertParams, convertResult as convertR } from 'app/common/api/requests/account/bank_details/post'
import { BankDetailProps } from 'app/dataTypes/account/bankDetails/BankDetailsTypes'


export default function useBankDetails() {
  const [bankDetails, setBankDetails] = useState<BankDetailProps>({} as BankDetailProps)
  const [loading, setLoading] = useState(true)

  const request = useCallback(async () => {
    setLoading(true)
    const res = await api.request(GET_BANK_DETAILS, {
      error: 'Не удалось получить данные реквизитов банка',
      convertions: {
        convertResult,
      },
    })

    setLoading(false)
    if (res) {
      setBankDetails(res)
    }
  }, [])

  useEffect(() => {
    request()
  }, [request])

  const updateBankDetails = useCallback(async (data: BankDetailProps) => {
    setLoading(true)
    const res = await api.request(POST_BANK_DETAILS, {
      error: 'Не удалось обновить данные реквизитов банка',
      params: {
        ...data,
      },
      convertions: {
        convertParams,
        convertResult: convertR,
      },
    })
    setLoading(false)
    return !!res
  }, [])

  return {
    bankDetails,
    updateBankDetails,
    loading,
  }
}
